// extracted by mini-css-extract-plugin
module.exports = {"root":"Checkbox.kaufland_root__2iBB2","isChecked":"Checkbox.kaufland_isChecked__37PUV","isLink":"Checkbox.kaufland_isLink__3jQN_","label":"Checkbox.kaufland_label__3XOCn"};